import { z } from 'my-zod'
import { riderShortView } from './rider-short-view'

export const updateInvitedGuestsSystemResponse = z.object({
  added: riderShortView.array(),
  deleted: riderShortView.array(),
  resulted: riderShortView.array()
})

export type updateInvitedGuestsSystemResponse = z.infer<typeof updateInvitedGuestsSystemResponse>
